export default __webpack_public_path__ + "static/media/american-gothic-styled-old-couple.2f4a3d67.svg";